export default "__VITE_ASSET__Bq78SBEb__"